import { Route } from 'react-router-dom'

import AppointmentDetailsPage from './AppointmentDetailsPage'
import OSASchedulingPage from './OSASchedulingPage'

export const routes = (
  <>
    <Route path="/osa-scheduling" element={<OSASchedulingPage />} />
    <Route path="/osa-scheduling/show/:id" element={<AppointmentDetailsPage />} />
  </>
)
